import { render, staticRenderFns } from "./MasterRegistration.vue?vue&type=template&id=3474c494&scoped=true"
import script from "./MasterRegistration.vue?vue&type=script&lang=js"
export * from "./MasterRegistration.vue?vue&type=script&lang=js"
import style0 from "./MasterRegistration.vue?vue&type=style&index=0&id=3474c494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474c494",
  null
  
)

export default component.exports